export default [
  {
    path: '/becarios',
    name: 'becarios-list',
    component: () => import('@/views/becarios/Index.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Becarios',
      breadcrumb: [
        {
          text: 'Listado de becarios',
          active: true,
        },
      ],
    },
  },
  {
    path: '/becario/:id/detalles',
    name: 'becario-detalles',
    component: () => import('@/views/becarios/components/Detalles.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      pageTitle: 'Becario detalles',
      breadcrumb: [
        {
          text: 'Listado de becarios',
          to: '/becarios',
          active: false,
        },
        {
          text: 'Detalles prebecario',
          active: true,
        },
      ],
    },
  },
  {
    path: '/becario/activo',
    name: 'becarios-activos',
    component: () => import('@/views/in_curse/Index.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Activos en convocatoria',
      breadcrumb: [
        {
          text: 'Listado de becarios activos en un curso',
          active: true,
        },
      ],
    },
  },
]
